//Suites 2 recamaras

// Premium Master Suite
import image1 from "../../assets/Suites/Suites 2 Recamaras/Master Executive Suite/MasterExecutiveSuite-1.webp"
import image2 from "../../assets/Suites/Suites 2 Recamaras/Master Executive Suite/MasterExecutiveSuite-2.webp"
import image3 from "../../assets/Suites/Suites 2 Recamaras/Master Executive Suite/MasterExecutiveSuite-3.webp"
import image4 from "../../assets/Suites/Suites 2 Recamaras/Master Executive Suite/MasterExecutiveSuite-4.webp"
import image5 from "../../assets/Suites/Suites 2 Recamaras/Master Executive Suite/MasterExecutiveSuite-5.webp"
import image6 from "../../assets/Suites/Suites 2 Recamaras/Master Executive Suite/MasterExecutiveSuite-6.webp"

const MasterExecutiveSuite = {
    "images":[
        {
        "original":image1,
        "thumbnail":image1
        },
        {
        "original":image2,
        "thumbnail":image2
        },
        {
        "original":image3,
        "thumbnail":image3
        },
        {
        "original":image4,
        "thumbnail":image4
        },
        {
        "original":image5,
        "thumbnail":image5
        },
        {
        "original":image6,
        "thumbnail":image6
        }
    ] 
}

export default MasterExecutiveSuite;